import { System } from "ngx-core-services";

export const getLabels = () => ({
  action: 'Selection',
  allPortedContained: 'Devices already ported',
  alreadyPortedWithAllDevices: 'Already ported with all devices',
  alreadyPortedWithSomeDevices: 'Already ported with some devices',
  authorizedDisclaimerContent: "You are not authorized to perform this action. To perform this action, you must be an installer, advanced installer or a service partner.",
  authorizedDisclaimerTitle: "authorizedDisclaimerTitle",
  closeButton: 'I Understood',
  confirm: 'confirm',
  connectedAndUpdated: 'Connected and updated',
  dialogTitle: 'Porting Report',
  disconnected: 'Disconnected',
  failedDescription: 'Plant Failed to Port',
  noResults: 'No results',
  notPortable: 'Not portable',
  notUpdated: 'Not updated',
  onlyPortable: 'Only portable',
  portable: 'Portable',
  portingButton: 'Update to Advanced Plant',
  portingFailureDescription: 'The not promoted plants contains devices that are in already promoted plants',
  portingReport: 'Porting report',
  portingReportDescription: 'Plants imported',
  searchOnTable: 'Search on table',
  successDescription: 'Plant Ported Successfully',
  systemDevices: 'Devices',
  systemName: 'Name',
  systemStatus: 'Status',
  title: 'Update to Advanced Plant',
  updated: 'Updated',
  hasAlerts: 'Has Alerts',
});

export const isListUpdated = (list: System[], prevList: System[] | null): boolean => {
  if (list.length !== prevList?.length) {
    return true;
  }
  for (let i = 0; i < list.length; i++) {
    if (list[i].uid !== prevList[i].uid) {
      return true;
    }
  }
  return false;
};

export const trackByFn = (_: number, item: any): string => item.system.uid;